const SENSITIVE_KEY =
  /^(authorization|jwt|rawquery|secret|sign|token|access[_-]?token|anon[_-]?key)$/i;

export function redactSensitive(
  value: unknown,
  seen = new WeakSet<object>(),
): unknown {
  if (Array.isArray(value)) {
    return value.map((item) => redactSensitive(item, seen));
  }

  if (typeof value !== 'object' || value === null) return value;

  if (seen.has(value)) return '[circular]';
  seen.add(value);

  return Object.fromEntries(
    Object.entries(value).map(([key, nested]) => [
      key,
      SENSITIVE_KEY.test(key)
        ? '[redacted]'
        : redactSensitive(nested, seen),
    ]),
  );
}

export function formatResult(value: unknown): string {
  if (value === undefined) return 'Completed without a response body.';

  try {
    return JSON.stringify(redactSensitive(value), null, 2);
  } catch {
    return String(value);
  }
}
